import request from "@/utils/request"

//文件上传
export function upLoadImg(data) {
  return request({
    url: '/uploadFile',
    method: 'post',
    data
  })
}

//判断token是否过期
export function isEnabled(data) {
  return request({
    url: '/sms/tokenIsEnabled',
    method: 'get',
    params: data
  })
}

//文件上传多个
export function upLoadImgS(data) {
  return request({
    url: '/uploadFiles',
    method: 'post',
    data
  })
}

//文件视频上传
export function upLoadImgVideo(data) {
  return request({
    url: '/aliYunVideo/videoUpload',
    method: 'post',
    data
  })
}

//code
export function codeList(data) {
  return request({
    url: '/code/getCode',
    method: 'get',
    params: data
  })
}

//分享接口
export function wxShare(data) {
  return request({
    url: '/wxShare/getShare',
    method: 'get',
    params: data
  })
}
//根据榜单id查询榜单赛区
export function getByListId(data) {
  return request({
    url: '/h5List/getByListId',
    method: 'get',
    params: data
  })
}

//根据榜单id查询榜单基础数据
export function selectByListId(data) {
  return request({
    url: '/h5List/selectByListId',
    method: 'get',
    params: data
  })
}
//活动详情
export function selectById(data) {
  return request({
    url: '/h5List/selectById',
    method: 'get',
    params: data
  })
}
//查询赛区下的名字
export function getAllAreaName(data) {
  return request({
    url: '/h5List/getAllAreaName',
    method: 'get',
    params: data
  })
}
//用户投票
export function updateVote(data) {
  return request({
    url: '/h5List/updateVote',
    method: 'post',
    data
  })
}
//投票后查询榜单的可视化
export function getVisualVoteResult(data) {
  return request({
    url: '/h5List/getVisualVoteResult',
    method: 'get',
    params: data
  })
}
